import { COLOR_FILTER } from '../../../constants/colorFilter';

const ColorCheckbox = ({ label, value, onChange, checked }) => {
  return (
    <div className="flex justify-between items-center mb-2">
      <div className={`flex gap-3 items-center checkbox-wrapper`}>
        <input
          className="form-check-input"
          type="checkbox"
          name="dataCheckbox"
          value={value}
          id={'flexCheckDefault' + label}
          onChange={onChange}
          checked={checked}
        />
        <label className="form-check-label" htmlFor={'flexCheckDefault' + label}>
          {label}
        </label>
      </div>
      <label
        htmlFor={'flexCheckDefault' + label}
        className={`border rounded-full border-[#918F8F] w-[20px] h-[20px]`}
        style={{
          background: COLOR_FILTER?.filter(
            (items) => items?.label.toUpperCase() === label.toUpperCase()
          )?.[0]?.value,
        }}
      />
    </div>
  );
};

export default ColorCheckbox;
